import { EImportEntity } from '../importer/model';
import { importReducer } from '../importer/reducer';

export const ancillaryTransfersRatesImport = importReducer(EImportEntity.ANCILLARY_TRANSFERS_RATES);
